import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import CropFreeIcon from '@material-ui/icons/CropFree';
import { getTransactionState } from '../../../store/global/selectors';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles((theme) => ({

  backgroundStyle: {
    position: "fixed",
    bottom: 10,
    left: 5,
    zIndex: 1000,
    width: 30,
    backgroundColor: '#FFF',
    display: 'block',
    alignItems: 'center',
    border: 'solid 1px #ccc',
  },
  icon: {
    color: '#000',
    width: '0.7em',
    height: '0.7em'
  },
  listItem: {
    //borderBottom: 'solid 1px #ccc',
    marginLeft: -11,
    height: 25
  }

}));

export default function TransactionZoomOptions({ zoomIn, zoomOut, reset }) {

  const classes = useStyles();
  const [disabled, setDisabled] = useState(true);
  const transactionState = useSelector(getTransactionState);

  useEffect(() => {
    let { drawEvent, drawNestedTransaction, drawReuseTransaction } = transactionState;
    let status = !drawEvent && !drawNestedTransaction && !drawReuseTransaction;
    setDisabled(status);
  }, [transactionState]);

  return (
    //     <ButtonGroup color="primary" aria-label="outlined primary button group" className={classes.backgroundStyle}>
    //     <Button variant='contained' color='primary' size='medium' onClick={zoomIn}>Zoom In</Button>
    //     <Button variant='contained' color='primary' size='medium' onClick={reset}>Reset</Button>
    //     <Button variant='contained' color='primary' size='medium' onClick={zoomOut}>Zoom Out</Button>
    //   </ButtonGroup>

    <List component="nav" aria-label="main mailbox folders" className={classes.backgroundStyle}>
      <ListItem button disabled={!disabled} onClick={zoomIn} className={classes.listItem} alignItems="center">
        <ListItemIcon>
          <AddIcon className={classes.icon} title="Zoom In" />
        </ListItemIcon>
      </ListItem>
      <Divider />
      <ListItem button disabled={!disabled} onClick={zoomOut} className={classes.listItem}>
        <ListItemIcon>
          <RemoveIcon className={classes.icon} title="Zoom Out" />
        </ListItemIcon>
      </ListItem>
      <Divider />
      <ListItem button disabled={!disabled} onClick={reset} className={classes.listItem}>
        <ListItemIcon id='resetPanBtn'>
          <CropFreeIcon className={classes.icon} title="Reset" />
        </ListItemIcon>
      </ListItem>
    </List>
  )
}